export default __webpack_public_path__ + "static/media/paypal.3af1b085.svg";